export type ValueOf<T> = T[keyof T];

export const OCPIAuthMethod = Object.freeze({
  AUTH_REQUEST: "AUTH_REQUEST",
  COMMAND: "COMMAND",
  WHITELIST: "WHITELIST"
})

export type OCPIAuthMethodKeys = keyof typeof OCPIAuthMethod;
export type OCPIAuthMethodValues = ValueOf<typeof OCPIAuthMethod>;